const rail = {
  rails: "울타리", // translated 
  senior: "상위", // translated 
  seniors: "어른", // translated 
  youths: "청소년", // translated 
  yearOld: "한 살", // translated 
  yearsOld: "세", // translated 
};


export default rail;
